import React, { useState, useEffect } from 'react';

interface LoadingSpinnerProps {
  message?: string;
  showRetryMessage?: boolean;
  onRetry?: () => void;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = "Loading...", 
  showRetryMessage = false,
  onRetry 
}) => {
  const [showSlowMessage, setShowSlowMessage] = useState(false);
  const [showRetryButton, setShowRetryButton] = useState(false);

  useEffect(() => {
    const slowTimer = setTimeout(() => setShowSlowMessage(true), 10000);
    const retryTimer = setTimeout(() => setShowRetryButton(true), 30000);
    return () => {
      clearTimeout(slowTimer);
      clearTimeout(retryTimer);
    };
  }, []);

  return (
    <div className="loading-container">
      <div className="loading-spinner">
        <div className="spinner"></div>
        <div className="loading-content">
          <h3>{message}</h3>
          
          {showSlowMessage && (
            <div className="loading-message">
              <p>⏰ This is taking longer than usual...</p>
              <p>The server may be starting up. Please wait a moment.</p>
            </div>
          )}
          
          {showRetryMessage && (
            <div className="loading-message">
              <p>🔄 The backend server may be starting up.</p>
              <p>This can take up to 60 seconds on the first request.</p>
            </div>
          )}
          
          {showRetryButton && onRetry && (
            <button onClick={onRetry} className="retry-button">
              🔄 Retry Connection
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;